'use strict';

/**
 * Checks if the device is an iOS device using Safari.
 *
 * @returns {boolean} - True if the device is an iOS device using Safari, false otherwise.
 */
function isIOSSafari() {
    var isSafariIOS = !!(navigator && navigator.userAgent && navigator.userAgent.match(/iPhone|iPad|iPod/i) && navigator.userAgent.match(/AppleWebKit/i));
    return !!isSafariIOS;
}

/**
 * Fills the OTP input fields with the provided pasted data and submits the OTP form.
 *
 * @param {jQuery} $otpInputs - A jQuery object containing the OTP input fields.
 * @param {string} pastedData - The data that was pasted into the OTP input fields.
 * @param {jQuery} $currentInput - The current input field that the user is interacting with.
 */
function fillAndSubmitOTPForm($otpInputs, pastedData, $currentInput) {
    if (!Number.isNaN(Number(pastedData)) && pastedData.length === $otpInputs.length) {
        $otpInputs.each(function (index) {
            $(this).val(pastedData[index] || '');
        });

        $('body').trigger('OTPpasted');

        $otpInputs.last().trigger('focus');
        $($currentInput).closest('.login-popup-modal-container').find('.otppopup-submitbutton').trigger('click');
    }
}

/**
 * Initializes event listeners for OTP input fields.
 *
 * This function sets up two event listeners on elements
 */
function init() {
    $(document).on('paste', '.otp-input', function (e) {
        const $otpInputs = $(this).closest('.otp-boxes-otp').find('.otp-input');
        e.preventDefault();
        const pastedData = e.originalEvent.clipboardData.getData('text').trim();

        fillAndSubmitOTPForm($otpInputs, pastedData, $(this));
    });

    $(document).on('beforeinput', '.otp-input', function (e) {
        const $otpInputs = $(this).closest('.otp-boxes-otp').find('.otp-input');
        const pastedData = e.originalEvent && e.originalEvent.data && e.originalEvent.data.toString().trim();
        if (pastedData && pastedData.length === 6) {
            e.preventDefault();
            fillAndSubmitOTPForm($otpInputs, pastedData, $(this));
        }
    });
}

module.exports = { init, isIOSSafari };
